.notification {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: absolute;
  /* it starts 6rem from the top instead of 0 because I found it's annoying in some
  cases to be in the shipment flow and have the notification occlude the 'continue' button */
  transform: translate(calc(100vw - calc(100% + 2rem)), 6rem);

  width: max-content;
  min-height: 2.5rem;
  max-width: 400px;

  background-color: var(--static-background-standard);
  padding: 0.75rem 2rem 0.75rem 0.75rem;
  border-radius: 10px;
  border: 1px solid var(--static-divider-standard);
  color: var(--static-text-standard);

  box-shadow: var(--box-shadow);
}
.notificationCloseIcon {
  position: absolute;
  right: 0;
  top: 0.5rem;
  color: var(--static-text-strong);
}

.popover {
  position: absolute;
  top: 0;
}
